import { render } from "./mProductCenter.vue?vue&type=template&id=db8bd35e&scoped=true"
import script from "./mProductCenter.vue?vue&type=script&lang=js"
export * from "./mProductCenter.vue?vue&type=script&lang=js"

import "./mProductCenter.vue?vue&type=style&index=0&id=db8bd35e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8bd35e"]])

export default __exports__